module.exports = __webpack_public_path__ + "static/media/doc-4.e2c5b842.jpg";